import {createReducer, on} from '@ngrx/store';
import {login, logout, updateAuthentication, updateUserRoles,} from '../actions/auth.actions';
import {Roles} from '../../../enum/roles';
import {Permissions} from '../../../enum/permissions';

export interface AuthState {
  isAuthenticated: boolean;
  roles: Roles[];
  permissions: Permissions[];
}

export const initialState: AuthState = {
  isAuthenticated: false,
  roles: [],
  permissions: [],
};

export const authReducer = createReducer(
  initialState,
  on(updateAuthentication, (state, {isAuthenticated}) => ({
    ...state,
    isAuthenticated: isAuthenticated,
  })),
  on(updateUserRoles, (state, {roles}) => ({
    ...state,
    roles: roles,
  })),
  on(login, (state, {isAuthenticated, roles, permissions}) => ({
    ...state,
    isAuthenticated: isAuthenticated,
    roles: roles,
    permissions: permissions,
  })),
  on(logout, (state, {isAuthenticated, roles}) => ({
    ...state,
    isAuthenticated: isAuthenticated,
    roles: roles,
    permissions: []
  }))
);
